// extracted by mini-css-extract-plugin
export default {"container":"related-footer_container__27eMu","title":"related-footer_title__342W8","grid":"related-footer_grid__2rMg7","item":"related-footer_item__TzRT1"};